import React from "react";

type DaySelectionPillsProps = {
  options: string[];
  value: string[];
  onChange: (next: string[]) => void;
  disabledOptions?: string[];
  size?: "sm" | "md" | "lg";
  className?: string;
};

const sizeClasses: Record<NonNullable<DaySelectionPillsProps["size"]>, string> = {
  sm: "h-9 px-3 text-sm",
  md: "h-10 px-3 text-sm",
  lg: "h-[50px] px-4 text-md",
};

export default function DaySelectionPills({
  options,
  value,
  onChange,
  disabledOptions = [],
  size = "md",
  className = "",
}: DaySelectionPillsProps) {
  const disabledSet = React.useMemo(() => new Set(disabledOptions), [disabledOptions]);

  const toggle = (day: string) => {
    if (disabledSet.has(day)) return;
    if (value.includes(day)) {
      onChange(value.filter((item) => item !== day));
      return;
    }
    onChange([...value, day]);
  };

  return (
    <div className={["flex flex-wrap items-center gap-3", className].filter(Boolean).join(" ")}>
      {options.map((day) => {
        const selected = value.includes(day);
        const disabled = disabledSet.has(day);
        return (
          <button
            key={day}
            type="button"
            onClick={() => toggle(day)}
            disabled={disabled}
            className={[
              "inline-flex items-center gap-2 rounded-full border transition-colors",
              sizeClasses[size],
              disabled ? "cursor-not-allowed opacity-45" : "",
              selected
                ? "border-brand-blue bg-bg-blue text-dark-black"
                : "border-light-grey bg-white text-dark-black hover:bg-primary",
            ].join(" ")}
          >
            <span
              className={[
                "inline-flex h-5 w-5 items-center justify-center rounded-full border",
                selected ? "border-brand-blue bg-brand-blue" : "border-light-grey bg-white",
              ].join(" ")}
            >
              {selected ? <img src="/icons/correct_white.svg" alt="" aria-hidden="true" className="h-3 w-3" /> : null}
            </span>
            <span className="text-sm">{day}</span>
          </button>
        );
      })}
    </div>
  );
}
